import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const IconAssignUsers = createSvgIcon(
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6667 16V14.6667C11.6667 13.9594 11.3857 13.2811 10.8856 12.781C10.3855 12.281 9.70724 12 9 12H3.66667C2.95942 12 2.28115 12.281 1.78105 12.781C1.28095 13.2811 1 13.9594 1 14.6667V16"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33268 9.33333C7.80544 9.33333 8.99935 8.13943 8.99935 6.66667C8.99935 5.19391 7.80544 4 6.33268 4C4.85992 4 3.66602 5.19391 3.66602 6.66667C3.66602 8.13943 4.85992 9.33333 6.33268 9.33333Z"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.666 16.0012V14.6679C15.6656 14.077 15.4689 13.5031 15.1069 13.0361C14.7449 12.5691 14.2381 12.2356 13.666 12.0879"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 4.08789C11.5736 4.23476 12.082 4.56836 12.4451 5.0361C12.8082 5.50384 13.0052 6.07911 13.0052 6.67122C13.0052 7.26334 12.8082 7.83861 12.4451 8.30635C12.082 8.77409 11.5736 9.10769 11 9.25456"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.666 6.33398V10.334"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.666 8.33398H15.666"
      stroke="#566EE5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "IconAssignUsers",
);

export default IconAssignUsers;
